import clamp from 'lodash.clamp';
import React from 'react';

import { MIN_TRACK_HEIGHT, MAX_TRACK_HEIGHT, DEFAULT_TRACK_HEIGHT } from '../config/consts';

interface TrackHeightCtx {
  trackHeight: number;
  setTrackHeight: (rowHeight: number) => void;
}

export const TrackHeightContext = React.createContext<TrackHeightCtx>({
  trackHeight: DEFAULT_TRACK_HEIGHT,
  setTrackHeight: () => {}
});

export const TrackHeightProvider = ({ children }: { children: React.ReactNode }) => {
  const [trackHeight, setTrackHeight] = React.useState(DEFAULT_TRACK_HEIGHT);

  const handleSetTrackHeight = (height: number) => {
    setTrackHeight(clamp(Math.round(height), MIN_TRACK_HEIGHT, MAX_TRACK_HEIGHT));
  };

  return (
    <TrackHeightContext.Provider value={{ trackHeight, setTrackHeight: handleSetTrackHeight }}>
      {children}
    </TrackHeightContext.Provider>
  );
};
